import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import type { components } from '@/types/apiSchema';

import { companiesQueryKeys } from './queryKeys';

type CompanyNoteResponse = components['schemas']['CompanyNoteResponse'];

export const useCompanyNotesQuery = (
  companyId: string,
  options?: Omit<
    UseQueryOptions<CompanyNoteResponse[] | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: companiesQueryKeys.notes(companyId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.companyNotes, {
        params: { path: { id: companyId } },
      });

      return data;
    },
    ...options,
  });
};
